import useGetCustomerMetafields from 'domains/Metafields/hooks/useGetCustomerMetafields';
import RenderMetafieldsWhen from '../../RenderMetafieldWhen';

type ConditionsInterface = {
  hasInternals: boolean;
  hasExternals: boolean;
  isAvailable: boolean;
};

interface RenderVariantMetafieldsWhenProps {
  conditions: ConditionsInterface[];
  children: React.ReactNode;
}

export default function RenderCustomerMetafieldWhen({
  conditions,
  children,
}: RenderVariantMetafieldsWhenProps) {
  const { isAvailable, hasInternals, hasExternals } =
    useGetCustomerMetafields();
  const values = { isAvailable, hasInternals, hasExternals };

  return (
    <RenderMetafieldsWhen values={values} conditions={conditions}>
      {children}
    </RenderMetafieldsWhen>
  );
}
